"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const Wrapper = exports.Wrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "eg2v4jp0"
} : {
  target: "eg2v4jp0",
  label: "Wrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "1u0ub29",
  styles: "position:fixed;left:0;right:0;bottom:0;z-index:2;height:70px;padding-bottom:10px;background-color:white;box-shadow:0 -2px 4px 0 rgba(0,0,0,0.1);display:flex;flex-direction:row;align-items:stretch"
} : {
  name: "1u0ub29",
  styles: "position:fixed;left:0;right:0;bottom:0;z-index:2;height:70px;padding-bottom:10px;background-color:white;box-shadow:0 -2px 4px 0 rgba(0,0,0,0.1);display:flex;flex-direction:row;align-items:stretch",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});